export default __webpack_public_path__ + "static/media/file-music.8706f434.svg";